export default "__VITE_ASSET__BeeQJXVf__"